import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const projectsApi = {
    getProjects: (): Observable<Dtos.GetProjectsResponse> => {
        //Create the request.
        let request: Dtos.GetProjects = new Dtos.GetProjects();

        //Send request.
        const response: Promise<Dtos.GetProjectsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getProjectById: (id: number): Observable<Dtos.GetProjectByIdResponse> => {
        //Create the request.
        let request: Dtos.GetProjectById = new Dtos.GetProjectById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetProjectByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setProject: (project: Dtos.Project): Observable<Dtos.SetProjectResponse> => {

        let request: Dtos.SetProject = new Dtos.SetProject();

        request.project = project;

        // send request
        const response: Promise<Dtos.SetProjectResponse> = client.post(request);

        return Observable.from(response);

    },
    createProject: (): Observable<Dtos.CreateProjectResponse> => {
        //Create the request.
        let request: Dtos.CreateProject = new Dtos.CreateProject();

        //Send request.
        const response: Promise<Dtos.CreateProjectResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateProject: (project: Dtos.Project): Observable<Dtos.ValidateProjectResponse> => {

        let request: Dtos.ValidateProject = new Dtos.ValidateProject();

        request.project = project;

        // send request
        const response: Promise<Dtos.ValidateProjectResponse> = client.post(request);

        return Observable.from(response);

    }
}